import React from "react";
import { FiTrash2, FiX } from "react-icons/fi";
import "../Logos.css";

const DeleteLogoEdit = ({
  setDeleteEditOpen,
  projectId,
  logoId,
  logoName,
  deleteLogo,
}) => {
  const close = () => setDeleteEditOpen(false);
  const handleDelete = () => {
    deleteLogo(projectId, logoId);
    close();
  };

  return (
    <div
      className="deleteLogoEditRoot"
      role="dialog"
      aria-modal="true"
      aria-labelledby="delete-logo-title"
      aria-describedby="delete-logo-description"
    >
      <button
        type="button"
        className="deleteLogoEditOverlay"
        aria-label="Cancel logo deletion"
        onClick={close}
      />
      <div className="containerDeleteLogoEdit">
        <button
          type="button"
          className="deleteLogoEditClose"
          aria-label="Close"
          onClick={close}
        >
          <FiX aria-hidden="true" />
        </button>

        <div className="deleteLogoEditIcon" aria-hidden="true">
          <FiTrash2 />
        </div>

        <h2 id="delete-logo-title" className="deleteLogoEditTitle">
          Delete{" "}
          <span className="deleteLogoEditName">
            {logoName || "this logo"}
          </span>{" "}
          from the library?
        </h2>
        <p id="delete-logo-description" className="deleteLogoEditCopy">
          This is different from removing it from this block. The asset may
          become unavailable in other projects.
        </p>
        <div className="deleteLogoEditActions">
          <button type="button" className="deleteLogoEditBtn" onClick={close}>
            Cancel
          </button>
          <button
            type="button"
            className="deleteLogoEditBtn deleteLogoEditBtn--danger"
            onClick={handleDelete}
          >
            Delete from Library
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteLogoEdit;
